import React from 'react';
import { Feature, MediaItemValue } from '@fulcrumapp/fulcrum-core';
import { MediaDisplayer, Metadata } from './media-displayer';
import configuredPhotoView from './configured-photo-view';
import PhotoThumbnail from './photo-thumbnail';
import PhotoMapView from '../photo-map-view';
import PhotoArcGisMapView from '../photo-arcgis-map-view';
import PhotoMetadataView from '../photo-metadata-view';
import { variation } from '../../../launch-darkly';

const ESRI_PHOTO_MAP_FLAG = 'media-viewer-esri-map';

const photoDisplayer: MediaDisplayer = {
  display: configuredPhotoView,
  thumbnail(
    item: MediaItemValue,
    onClick: (item: MediaItemValue) => void,
    extraStyles: React.CSSProperties,
  ): React.ReactElement {
    return (
      <PhotoThumbnail
        item={item}
        styles={extraStyles}
        handleClick={() => onClick(item)}
      />
    );
  },
  mapView(
    item: MediaItemValue,
    metadata: Metadata,
    cssClass: string,
    feature?: Feature,
    visible?: boolean,
  ): React.ReactElement {
    if (variation(ESRI_PHOTO_MAP_FLAG, false)) {
      return (
        <PhotoArcGisMapView
          className={cssClass}
          feature={feature}
          metadata={metadata}
          visible={visible}
        />
      );
    }
    return (
      <PhotoMapView
        className={cssClass}
        item={item}
        feature={feature}
        metadata={metadata}
        visible={visible}
      />
    );
  },
  metadata(item: MediaItemValue, metadata: Metadata, cssClass: string, feature?: Feature): React.ReactElement {
    return (
      <PhotoMetadataView
        className={cssClass}
        item={item}
        feature={feature}
        metadata={metadata}
      />
    );
  },
};

export default photoDisplayer;
